export default "__VITE_ASSET__97db81ee__"